import type { RootState } from "@/store"

const selectMatchSession = () => (state: RootState) => state.match.matchSession
const selectIsSocketConnected = () => (state: RootState) =>
  state.match.isSocketConnect

export const MatchSelectors = { selectMatchSession, selectIsSocketConnected }
